import { useAddSetsToAssignmentMutation, useGetDBQSetsMutation, useGetSetQuestionsMutation } from '../../../../features/authentication/questionSearchApiSlice';
import { useGetDBQCoursesMutation } from '../../../../features/authentication/authApiSlice';
import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretUp, faCaretDown, faCircleQuestion } from '@fortawesome/free-solid-svg-icons';
import { faSearch, faPlus } from '@fortawesome/pro-solid-svg-icons';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import CustomToast from '../../../../components/Toast';
import AddQuestionsToExisting from '../castleQuestionsSearch/components/questionResults/components/addQuestionsToExisting';
import DropDown from '../../../../../src/components/DropDown';
import Badge from 'react-bootstrap/Badge';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import SetView from './SetView';
import { useAssignmentContext } from '../../../assignments/context';
import AddQuestionsToAssignment from '../addQuestionsToAssignment';
import AssignmentStatus from '../../../../enums/assignmentStatus';
import { DataProvider } from '../../../assignments/DataContext';
import AssignmentCreateContent from '../../../assignments/components/AssignmentCreateContent';
import TableSkeleton from '../../../../components/SkeletonLoader/TableSkeleton';
import CreateQuestionSetModel from '../../../myContent/pages/questionSets/components/CreateQuestionSetModel';
import { useAddSetsToQSetMutation } from '../../../../features/authentication/qSetApiSlice';

const DBQSets = () => {
  const [getDBQSets] = useGetDBQSetsMutation();
  const [addSetQuestionsToAssignment] = useAddSetsToAssignmentMutation();
  const [addSetsToQSet] = useAddSetsToQSetMutation();
  
  const [getDBQCourses] = useGetDBQCoursesMutation();
  const [getSetQuestions] = useGetSetQuestionsMutation();
  const [dbqSetsData, setDbqSetsData] = useState(null);
  const [sortColumn, setSortColumn] = useState('lName');
  const [sortDirection, setSortDirection] = useState('asc');
  const { assignmentId, from, qSetId } = useParams();
  const [openOptionTileModal, setOpenOptionTileModal] = useState(false);
  const [selectedSetId, setSelectedSetId] = useState(null);
  const [courseList, setCourseList] = useState([]);
  const [selectedCourseId, setSelectedCourseId] = useState(null);
  const [openPreviewModal, setOpenPreviewModal] = useState(false);
  const [previewData, setPreviewData] = useState(null);
  const [openItems, setOpenItems] = useState([]);
  const [bookletStartClicked, setBookletStartClicked] = useState(false);
  const [dateBasedKey, setDateBasedKey] = useState(new Date().getTime().toString());
  const { mcChoices, assignmentAssignedViaDetails, setAssignmentAssignedViaDetails } = useAssignmentContext();
  const { state } = useLocation();
  const navigate = useNavigate();
  const [openQsetCreateModal, setOpenQsetCreateModal] = useState(false);

  const saveComponentAddToExisting = <AddQuestionsToExisting key={'update' + dateBasedKey}
    handleSave={(id) => addSetQuestionsToExistingAssignment(id, selectedSetId)}
    handleCancel={() => setOpenOptionTileModal(false)} />;

  const saveComponentCreate = <DataProvider>
    <AssignmentCreateContent
      key={'create' + dateBasedKey}
      showBrowseContent={false}
      showTitle={false} showCancelButton={true}
      handleCancel={() => setOpenOptionTileModal(false)}
      onCreateSuccess={(id, assignedViaDetails) => addSetQuestionsToExistingAssignment(id, selectedSetId, assignedViaDetails)}
    /></DataProvider>;

  const handleAddQuestions = async (setId) => {
    if (!setId) {
      CustomToast('Please select set to add', 'error');
      return;
    }
    setSelectedSetId(setId);

    if(from == 'qSet')
    {
      if (qSetId) {
        addQuestionsToQSet(qSetId,setId);
      } else {
        setOpenQsetCreateModal(true);
      }
    }
    else{
      if (assignmentId) {
        addSetQuestionsToExistingAssignment(assignmentId, setId);
      } else {
        setOpenOptionTileModal(true);
      }
    }
  };

  const addSetQuestionsToExistingAssignment = async (existingAssignmentId, setId, assignedViaDetails) => {
    var options = {
      assignmentId: existingAssignmentId,
      setIds: [setId]
    };
    const response = await addSetQuestionsToAssignment(options);
    if (response.error) {
      CustomToast(response.error.data.error, 'error');
    }
    else {
      CustomToast('Selected Sets Questions are added', 'success');
      setOpenOptionTileModal(false);

      if (assignmentAssignedViaDetails?.id == null && assignedViaDetails?.id != null)
        setAssignmentAssignedViaDetails({ assignedViaDetails });

      navigate('/assignments/' + existingAssignmentId + '/edit_assignment', { state: { assignedStatus: AssignmentStatus.NotAssigned, mcChoices: mcChoices } });
    }
  };

  const addQuestionsToQSet = async (qSetId, setId) => {
    var options = {
      id: qSetId,
      setIds: [setId]
    };
    const response = await addSetsToQSet(options);
    if (response.error) {
      CustomToast(response.error.data.error, 'error');
    }
    else {
      CustomToast('Selected Sets Questions are added', 'success');
      setOpenQsetCreateModal(false);
      navigate('/mycontent/questionsets/'+qSetId+'/questions');
    }
  };

  async function loadDBQSets(courseId) {
    const option = {
      courseId: courseId
    };
    var result = await getDBQSets(option).unwrap();
    setDbqSetsData(result);
  }

  async function loadCourses() {
    var courses = await getDBQCourses().unwrap();
    var defaultSelected = courses.find(x => x.id === 24) ? courses.find(x => x.id === 24).id : courses[0].id;

    setCourseList(courses);
    loadDBQSets(defaultSelected);
    setSelectedCourseId(defaultSelected);
  }

  useEffect(() => {
    loadCourses();
    if (state?.assignedViaDetails)
      setAssignmentAssignedViaDetails({ id: state.assignedViaDetails.id, name: state.assignedViaDetails.name });
  }, []);

  const handleSort = (column) => {
    var direction = sortColumn === column && sortDirection === 'asc' ? 'desc' : 'asc';
    setSortColumn(column);
    setSortDirection(direction);
    sortString(column, direction);
  };

  const sortString = (column, direction) => {
    var sortedValue = [...dbqSetsData].sort((a, b) => {
      return direction === 'asc' ? a[column].localeCompare(b[column]) : b[column].localeCompare(a[column]);
    });

    setDbqSetsData(sortedValue);
  };

  const renderSortIcons = (column) => {
    if (sortColumn === column) {
      return sortDirection === 'asc' ?
        <span className='d-flex flex-column'>
          <FontAwesomeIcon icon={faCaretUp} size="sm" />
          <FontAwesomeIcon icon={faCaretDown} size="sm" className='align-caret-down opacity-25' />
        </span>
        :
        <span className='d-flex flex-column'>
          <FontAwesomeIcon icon={faCaretUp} size="sm" className='opacity-25' />
          <FontAwesomeIcon icon={faCaretDown} size="sm" className='align-caret-down' />
        </span>;
    }
    return (
      <span className='d-flex flex-column'>
        <FontAwesomeIcon icon={faCaretUp} size="sm" className='opacity-25' />
        <FontAwesomeIcon icon={faCaretDown} size="sm" className='align-caret-down opacity-25' />
      </span>
    );
  };

  const handleView = async (setId) => {
    setBookletStartClicked(false);
    setPreviewData(null);
    setOpenPreviewModal(true);
    const option = {
      courseId: selectedCourseId,
      setId: setId,
      languageId: 0
    };
    var result = await getSetQuestions(option).unwrap();
    setPreviewData(result);
    setOpenItems(result.setQuestions.map(() => false));
  };

  const handleCourseChange = (e) => {
    setDbqSetsData(null);
    setSelectedCourseId(parseInt(e.target.value));
    loadDBQSets(parseInt(e.target.value));
  };

  const newBadge = () => {
    return (<Badge bg="warning">New</Badge>);
  };

  const togglePreviewQuestions = (isBooklet, index) => {
    setOpenItems((prevOpenItems) =>
      prevOpenItems.map((isOpen, i) => (i === index ? !isOpen : isOpen))
    );

    if (isBooklet) {
      const container = document.querySelector('table.booklet').closest('div');
      const startPageElement = container.querySelector('#page0');
      startPageElement.style.display = 'none';
    }
  };

  useEffect(() => {
    if (!assignmentId && selectedSetId != null) {
      setDateBasedKey(new Date().getTime().toString());
    }
  }, [selectedSetId]);

  return (
    <>
      <div className="whiteCard">
        <div>
          <div id="dropdown_container" className="d-flex flex-column justify-content-start w-25 pb-3">
            Course
            <DropDown
              value={courseList}
              selectedValue={selectedCourseId}
              onChangeHandler={handleCourseChange}
            />
          </div>
          <div className='w-100 d-flex mb-4 gap-2'>
            <div><h6 className='w-100'>Sets from Topic</h6></div>
            <div>
              <OverlayTrigger
                key="set-topic-info"
                placement="right"
                overlay={
                  <Tooltip id="parent-tooltip" className="folder-info">
                    Click a
                    <button
                      id={'viewSet'}
                      className="action-btn-tile blue">
                      <FontAwesomeIcon icon={faSearch} />
                    </button>
                    icon to view set or
                    <button
                      id={'add'}
                      className="action-btn-tile green">
                      <FontAwesomeIcon icon={faPlus} />
                    </button>
                    icon to add the set into your assignment
                  </Tooltip>
                }>
                <FontAwesomeIcon icon={faCircleQuestion} className="circle-question" />
              </OverlayTrigger>
            </div>
          </div>
        </div>
        <div className='custom-table'>
          <table className='table reportTable'>
            {dbqSetsData? (
              <>
                <thead className='thead-light align-middle'>
                  <tr>
                    <th scope="col" className='fw-medium cursor-pointer min-w-150' onClick={() => handleSort('label')}>
                      <span className='align-items-center d-flex justify-content-between'> <span>Label</span> {renderSortIcons('label')} </span>
                    </th>
                    <th scope="col" className='fw-medium cursor-pointer' onClick={() => handleSort('topicName')}>
                      <span className='align-items-center d-flex justify-content-between'><span>Topics</span> {renderSortIcons('topicName')}</span>
                    </th>
                    <th scope="col" className='fw-medium cursor-pointer' onClick={() => handleSort('description')}>
                      <span className='align-items-center d-flex justify-content-between'><span>DBQ Name</span> {renderSortIcons('description')}</span>
                    </th>
                    <th scope="col" className='fw-medium cursor-pointer min-w-150' onClick={() => handleSort('lexile')}>
                      <span className='align-items-center d-flex justify-content-between'><span>Lexile</span> {renderSortIcons('lexile')}</span>
                    </th>
                    <th scope="col" className='fw-medium min-w-150'>
                      <span className='align-items-center d-flex justify-content-between'>     </span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {dbqSetsData?.map((item) => (
                    <tr key={`record_${item.id}`}>
                      <td className='min-w-150'>{item.label == '000' ? newBadge() : item.label}</td>
                      <td dangerouslySetInnerHTML={{ __html: item.topicName }}></td>
                      <td dangerouslySetInnerHTML={{ __html: item.description }}></td>
                      <td className='min-w-150'>{item.lexile}</td>
                      <td className='min-w-150'>
                        <OverlayTrigger
                          key="viewSet"
                          placement="top"
                          overlay={<Tooltip className="custom-tooltip">View Set</Tooltip>}>
                          <button
                            id={'viewSet' + item.id}
                            className="action-btn-tile blue"
                            onClick={async () => { handleView(item.id); }}
                          >
                            <FontAwesomeIcon icon={faSearch} />
                          </button>
                        </OverlayTrigger>

                        <OverlayTrigger
                          key="addSet"
                          placement="top"
                          overlay={<Tooltip className="custom-tooltip">Add Set To Assignment</Tooltip>}>
                          <button
                            id={'add' + item.id}
                            className="action-btn-tile green"
                            onClick={async () => { handleAddQuestions(item.id); }}
                          >
                            <FontAwesomeIcon icon={faPlus} />
                          </button>
                        </OverlayTrigger>
                      </td>
                    </tr>
                  ))}
                  {dbqSetsData?.length==0 && <tr>
                    <td colSpan='5' className='p-3 text-danger'>No dbq are available for the selected course</td>
                  </tr>}
                </tbody>
              </>
            ) : 
              <TableSkeleton
                colCount={5}
                rowCount={4}
              />}
          </table>
        </div>
      </div>
      <AddQuestionsToAssignment
        key={'component' + dateBasedKey}
        openOptionTileModal={openOptionTileModal}
        setOpenOptionTileModal={setOpenOptionTileModal}
        saveComponentCreate={saveComponentCreate}
        saveComponentAddToExisting={saveComponentAddToExisting}
      />
      {openQsetCreateModal &&
        <CreateQuestionSetModel
          key={'createQSet' + dateBasedKey}
          isOpen={openQsetCreateModal}
          onClose={() => setOpenQsetCreateModal(false)}
          showQuestionOptions={false}
          onCreateSuccess={(qSetId)=>addQuestionsToQSet(qSetId, selectedSetId)}
        />
      }
      <SetView
        openPreviewModal={openPreviewModal}
        setOpenPreviewModal={setOpenPreviewModal}
        previewData={previewData}
        openItems={openItems}
        togglePreviewQuestions={togglePreviewQuestions}
        setBookletStartClicked={setBookletStartClicked}
        bookletStartClicked={bookletStartClicked}
        isDbqSet={true}
      />
    </>
  );
};

export default DBQSets;
